module.exports = __webpack_public_path__ + "static/capterra-c41a16b5842cf5284fd4357f768ccb29.png";